<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal">
            <section class="planosWrapper">
                <section class="searchResultsWrapper">
                    <Loader :loading="loading" v-if="loading"></Loader>
                    <section>
                        <div class="row d-flex align-items-end mb-5">
                            <div class="col">
                                <div class="row">
                                    <div class="col zone-header">
                                        <h1 class="zone-header-title">{{ $t("help.title") }}</h1>
                                    </div>
                                </div>
                                <div class="row ">
                                    <div class="col d-flex align-items-center">
                                        <input type="text" id="searchBySearch" class="rem3rch-input-text" v-model="search" />
                                        <label for="searchBySearch" class="m-0 pointer ml-3"><i class="fa fa-search fa-lg color-grey"></i></label>
                                    </div>
                                </div>
                                <div class="row d-flex align-items-center mt-5">
                                    <div class="col-12 col-sm-2 admin-user-manage">
                                        <span class="">{{ $t("help.filter") }} :</span>
                                    </div>
                                    <div class="col-12 col-sm-10">
                                        <ClientColorButton
                                            @click="changeApp(app)"
                                            v-bind:key="key"
                                            v-for="(app, key) in apps"
                                            size="l"
                                            class="mr-4"
                                            :background-color="selectedApp && selectedApp.id === app.id ? 'black' : 'grey'"
                                        >
                                            {{ app.title }}
                                        </ClientColorButton>
                                    </div>
                                </div>
                                <div class="row d-flex align-items-center mt-5">
                                    <div class="col-12 col-sm-2 admin-user-manage">
                                        <span class="">{{ $t("help.category") }} :</span>
                                    </div>
                                    <div class="col-12 col-sm-10">
                                        <ClientColorButton
                                            @click="changeType('pdf')"
                                            size="l"
                                            class="mr-4"
                                            :background-color="selectedType === 'pdf' ? 'black' : 'grey'"
                                        >
                                            {{ $t("help.howTo") }}
                                        </ClientColorButton>
                                        <ClientColorButton
                                            @click="changeType('video')"
                                            size="l"
                                            class="mr-4"
                                            :background-color="selectedType === 'video' ? 'black' : 'grey'"
                                        >
                                            {{ $t("help.videoTraining") }}
                                        </ClientColorButton>
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto" v-if="isSuperAdmin()">
                                <div class="zone-header d-flex flex-column">
                                    <button class="btn btn-add-zone mb-4" @click="showModalUploadPdf = true">
                                        <i class="fa fa-plus fa-xs"></i> <span class="ml-2">{{ $t("help.newPdf") }}</span>
                                    </button>
                                    <button class="btn btn-manage-group" @click="showModalUploadVideo = true">
                                        <i class="fa fa-plus fa-xs"></i> <span class="ml-2">{{ $t("help.newVideo") }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4" v-if="!loading">
                            <table class="table">
                                <tbody>
                                    <tr class="notfound" v-if="filesFiltered.length <= 0">
                                        <td :colspan="11">{{ $t("help.noItem") }}</td>
                                    </tr>
                                    <tr v-bind:key="key" v-for="(file, key) in filesFiltered">
                                        <td class="icone" v-if="file.type === 'pdf'">
                                            <template>
                                                <a target="_blank" v-if="file.type === 'pdf'" :href="linkFile(file.application.name, file.filename)">
                                                    <IconePdf></IconePdf>
                                                </a>
                                            </template>
                                        </td>
                                        <td class="icone" v-else-if="file.type === 'video'">
                                            <a target="_blank" :href="file.link">
                                                <template>
                                                    <IconeVideo></IconeVideo>
                                                </template>
                                            </a>
                                        </td>
                                        <td>
                                            <a target="_blank" v-if="file.type === 'pdf'" :href="linkFile(file.application.name, file.filename)">{{
                                                file.name
                                            }}</a>
                                            <a target="_blank" v-else-if="file.type === 'video'" :href="file.link">{{ file.name }}</a>
                                        </td>
                                        <td class="edit text-center" v-if="isSuperAdmin()">
                                            <img class="position-relative" src="../../assets/edit.svg" alt="edit" @click="showModalModify(file)" />
                                        </td>
                                        <td class="delete shrink text-center" v-if="isSuperAdmin()">
                                            <img class="position-relative" src="../../assets/delete.svg" alt="edit" @click="deleteHelpFile(file)" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </section>
            </section>
        </section>
        <ModalHelpUpload
            v-if="showModalUploadPdf"
            :selected-application-id="selectedApp.id"
            :applications="apps"
            :type-upload="'pdf'"
            :selected-file="selectedHelpingFile"
            @uploadSuccess="uploadSuccess"
            @closed="
                showModalUploadPdf = false;
                selectedHelpingFileId = null;
            "
        ></ModalHelpUpload>
        <ModalHelpUpload
            v-if="showModalUploadVideo"
            :selected-application-id="selectedApp.id"
            :applications="apps"
            :type-upload="'video'"
            :selected-file="selectedHelpingFile"
            @uploadSuccess="uploadSuccess"
            @closed="
                showModalUploadVideo = false;
                selectedHelpingFileId = null;
            "
        ></ModalHelpUpload>
    </div>
</template>
<script>
import { APPLICATION } from "@/components/admin/brand/constant";
import helpService from "@/services/help";
import Globals from "@/components/globals";
import Template from "@/plano/template";
import Loader from "@/components/loader/loader";
import ModalHelpUpload from "@/components/help/modales/ModalHelpUpload";
import IconePdf from "@/components/help/svg/IconePdf";
import IconeVideo from "@/components/help/svg/IconeVideo";
import TryLoad from "@/mixins/TryLoadMixin";

export default {
    components: { ModalHelpUpload, Template, Loader, IconePdf, IconeVideo },
    data() {
        return {
            search: "",
            APPLICATION,
            apps: [
                { id: APPLICATION.CATALOG_ID, title: this.$t("help.catalog") },
                { id: APPLICATION.FORECAST_ID, title: this.$t("help.launch_forecast") },
                { id: APPLICATION.CATALOG_FORECAST_ID, title: this.$t("help.catalog_forecast") },
                { id: APPLICATION.TOOLS_ID, title: this.$t("help.tools") }
            ],
            selectedApp: null,
            selectedType: null,
            files: [],
            loading: true,
            showModalUploadPdf: false,
            showModalUploadVideo: false,
            selectedHelpingFile: null
        };
    },
    computed: {
        filesFiltered() {
            let result = this.files;
            if (this.selectedApp != null) result = this.files.filter(f => f.application.id === this.selectedApp.id);
            if (this.selectedType != null) result = result.filter(f => f.type === this.selectedType);
            if (this.search !== "") {
                result = result.filter(f => {
                    return f.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
                });
            }
            return result;
        }
    },
    mixins: [TryLoad],
    async created() {
        // this.changeApp(this.apps[0]);
        await this.loadFiles();
    },
    mounted() {},
    methods: {
        linkFile(filepath, filename) {
            return Globals.getApiUrl() + "/help/" + filepath + "/" + filename;
        },
        isSuperAdmin() {
            return this.$accessUser.isSuperAdmin();
        },
        async loadFiles() {
            this.loading = true;
            this.files = await helpService.getList();
            this.loading = false;
        },
        uploadSuccess(appId) {
            this.showModalUploadVideo = false;
            this.selectedHelpingFile = null;
            this.showModalUploadPdf = false;
            this.selectedApp = this.apps.filter(app => app.id === appId)[0];
            this.loadFiles();
        },
        changeApp(app) {
            if (this.selectedApp === app) {
                this.selectedApp = null;
            } else {
                this.selectedApp = app;
            }
        },
        changeType(type) {
            if (this.selectedType === type) {
                this.selectedType = null;
            } else {
                this.selectedType = type;
            }
        },
        showModalModify(file) {
            this.selectedHelpingFile = file;
            if (file.type === "pdf") {
                this.showModalUploadPdf = true;
            } else {
                this.showModalUploadVideo = true;
            }
        },
        async deleteHelpFile(file) {
            const res = await this.dialogConfirm("Are you sure you want to delete this content ?", "Delete", "Cancel");
            if (res === true) {
                await this.tryLoad(() => helpService.delete(file.id));
                await this.loadFiles();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.planosWrapper {
    background-color: #fff;
    padding: 30px;
    padding-top: 50px;

    .admin-user-manage {
        span {
            font-size: 18px;
            font-weight: bold;
            color: grey;
        }
    }

    .zone-header {
        .zone-header-title {
            color: #6f6f6f;
            font-size: 30px;
            margin: 0;
            text-transform: uppercase;
            font-family: "Oswald", sans-serif;
            font-weight: normal;
            display: block;
            margin-bottom: 40px;
        }
        .btn-add-zone,
        .btn-manage-group {
            width: 100%;
            padding: 10px 25px;
            background-color: #000;
            color: #fff;
            span {
                text-transform: uppercase;
                font-size: 14px !important;
                font-family: "Roboto", sans-serif;
            }
        }
    }
}
.marginButton {
    margin: 3px;
}
.color-grey {
    color: #6f6f6f !important;
}

table {
    border-collapse: collapse;
    tr {
        background-color: #f4f4f4;
        border-bottom: #fff 5px solid;
        vertical-align: middle;
        &.notfound {
            height: 150px;
            td {
                text-align: center;
                font-size: 18px;
                line-height: 18px;
                padding: 10px;
                color: #262626;
                vertical-align: middle;
            }
        }
        td {
            padding: 10px;
            vertical-align: middle;
            overflow-wrap: break-word;
            color: black;
            font-size: 20px;
            line-height: 20px;
            transition: 0.3s ease-in-out;
            font-weight: 500;
            span,
            a {
                font-size: 18px;
                font-weight: 500;
                color: black;
                &:hover {
                    text-decoration: none;
                }
            }

            svg {
                width: 70px;
            }

            svg,
            span,
            img {
                cursor: pointer;
            }

            &.icone {
                width: 15%;
            }

            &.edit,
            &.delete {
                width: 70px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Help.vue?6e2bc940